import { getSegmentById } from './getSegmentById';
import { segmentChanged } from './segmentChanged';

import { convertFromNewUiToQueryFormat, GlobalFilter } from '@hotjar/global-filters';
import type { Segment } from '@hotjar/global-filters/src/domains/global-filters/model/segment';
import type { Store } from '../../../store/list/types';

// @NOTE We currently pass down the site which it's not used by updateFilterAndUrl. This pattern should be revisited.
//       We can read the current site from cache.
export const updateFilterAndUrl = (
  store: Store,
  filtersInUiFormat: GlobalFilter,
  optionalSegmentId?: number,
): void => {
  const { loaded, segments, setCurrentPage, setCurrentSegment } = store.getState();
  const jsonFilters = convertFromNewUiToQueryFormat(filtersInUiFormat);
  /**
   *reset pagination, to avoid showing empty pages due to filtering
   */
  setCurrentPage(1);

  const searchParams = new URLSearchParams(window.location.search);
  const initialParams = searchParams.toString();

  const shouldReplaceState = !searchParams.get('filters') && !searchParams.get('segment');

  if (optionalSegmentId) {
    searchParams.set('segment', optionalSegmentId.toString());
    searchParams.delete('filters');

    setCurrentSegment(getSegmentById(optionalSegmentId, segments) as Segment);
  } else {
    const queryString = JSON.stringify(jsonFilters);
    searchParams.delete('segment');
    searchParams.set('filters', queryString);

    setCurrentSegment(null);
  }

  if (initialParams !== searchParams.toString()) {
    window.history[shouldReplaceState ? 'replaceState' : 'pushState'](
      null,
      '',
      `${window.location.pathname}?${searchParams.toString()}`.replaceAll('%3A', ':'),
    );
  }

  if (loaded) {
    segmentChanged(store, jsonFilters);
  }
};
